<template>
  <div class="highlight-list-tab-parts">
    <ul class="highlight-list-tab-parts__tabs">
      <li class="highlight-list-tab-parts__tab">
        <button
          class="highlight-list-tab-parts__tab-button"
          :class="[
            `highlight-list-tab-parts__tab-button-official`,
            { 'highlight-list-tab-parts__tab-button--active': selectedHighlightTab === 'official' },
          ]"
          @click="handleTabClicked('official')"
        >
          {{ $tc('RaceVideoPage.highlights.tabText.official') }}
        </button>
      </li>
      <li class="highlight-list-tab-parts__tab">
        <button
          class="highlight-list-tab-parts__tab-button"
          :class="[
            `highlight-list-tab-parts__tab-button-user`,
            { 'highlight-list-tab-parts__tab-button--active': selectedHighlightTab === 'user' },
          ]"
          @click="handleTabClicked('user')"
        >
          {{ $tc('RaceVideoPage.highlights.tabText.user') }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import type { HighlightTabsType } from '@/store/stores/pageStore/RaceVideoPage/RaceVideoPageStore'

/**
 * レース動画再生画面 ハイライト表示 ハイライトタブのパーツ
 */
export default defineComponent({
  name: 'HighlightListTabParts',
  props: {
    /**
     * 選択中のハイライトタブ
     */
    selectedHighlightTab: {
      type: String as PropType<HighlightTabsType>,
      required: true,
    },
  },
  setup(_props, { emit }) {
    /**
     * 公式とユーザーの切り替えボタンが押下されたときの処理
     * @param {string} tabId
     */
    const handleTabClicked = (tabId: HighlightTabsType) => {
      emit('onClickHighlightTab', tabId)
    }

    return {
      handleTabClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.highlight-list-tab-parts {
  position: relative;

  &::before {
    position: absolute;
    top: -16px;
    left: 50%;
    width: 2px;
    height: 16px;
    content: '';
    background-color: rgba(#e5e5e5, 0.5);
    transform: translateX(-50%);
  }

  &__tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 148px;
    height: 36px;
    padding: 2px;
    border-radius: 18px;
    background-color: rgba(#909090, 0.3);
  }

  &__tab {
    &-button {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 72px;
      height: 32px;
      font-size: 12px;
      font-weight: 600;
      color: $white;
      letter-spacing: 0.04em;

      &-official {
        border-radius: 16px 2px 2px 16px;
      }

      &-user {
        border-radius: 2px 16px 16px 2px;
      }

      &--active {
        color: $black;
        background-color: $white;
        pointer-events: none;
      }
    }
  }
}
</style>
